import type {
    FC
} from "react";
import type {
    PreferenceFormProps
} from "../type";
import PreferenceSegment from "../segment";
import PreferenceMenu from "../menu";

const PreferenceForm: FC<PreferenceFormProps> = ({
    spreadBehaviour,
    customLocalize,
    customTheme,
    isShowTitle,
    isDisabled,
    activeKey,
    onSelect,
    options,
    trigger,
    testID,
    style,
    title,
    form,
    size
}) => {
    if(form === "segment") {
        return <PreferenceSegment
            spreadBehaviour={spreadBehaviour}
            customLocalize={customLocalize}
            isShowTitle={isShowTitle}
            customTheme={customTheme}
            isDisabled={isDisabled}
            activeKey={activeKey}
            onSelect={onSelect}
            options={options}
            testID={testID}
            style={style}
            title={title}
            size={size}
        />;
    }

    if(form === "menu") {
        return <PreferenceMenu
            customLocalize={customLocalize}
            customTheme={customTheme}
            isDisabled={isDisabled}
            activeKey={activeKey}
            onSelect={onSelect}
            options={options}
            trigger={trigger}
            title={title}
        />;
    }

    return trigger;
};
export default PreferenceForm;
